import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store from "./store";
import "./index.css";
import App from "./App";
import ReactGA from 'react-ga'
import './console-disable'; 
// import { unregister } from "./registerServiceWorker";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import swDev from "./swDev";
// import {hydrate, render} from "react-dom";
const TRACKING_ID = "UA-257764354-1"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

// ReactDOM.render(
    // <Fragment>
    //     <ToastContainer />
    //     <Provider store={store}>
    //         <App />
    //     </Provider>
    // </Fragment>,
    // document.getElementById("root")
// );

// const rootElement = document.getElementById("root");
// if (rootElement?.hasChildNodes()) {
//   hydrate(<App />, rootElement);
// } else {
//   render(<App />, rootElement);
// }
const rootElement = document.getElementById("root");
if(rootElement?.hasChildNodes())
{

    ReactDOM.hydrate(<Fragment>
        <ToastContainer />
        <Provider store={store}>
            <App />
        </Provider>
    </Fragment>,rootElement);
}else{
    ReactDOM.render(<Fragment>
        <ToastContainer />
        <Provider store={store}>
            <App />
        </Provider>
    </Fragment>,rootElement);
}

// unregister();
// serviceWorkerRegistration.unregister();
swDev();

